import { LayoutAddiScreenTabletMin, LayoutAddiScreenDesktopMin, LayoutAddiScreenDesktopMax, LayoutAddiScreenMobileSmallMin, LayoutAddiGridMobileGap, LayoutAddiGridTabletGap, LayoutAddiGridDesktopGap, LayoutAddiGridMobileGutter, LayoutAddiGridTabletGutter, LayoutAddiGridDesktopGutter } from '@addi/foundation/dist/web/layout';
export const MEDIA_QUERY_DEVICE = {
    MOBILE: `(min-width: ${LayoutAddiScreenMobileSmallMin})`,
    TABLET: `(min-width: ${LayoutAddiScreenTabletMin})`,
    DESKTOP: `(min-width: ${LayoutAddiScreenDesktopMin})`,
    DESKTOP_HD: `(min-width: ${LayoutAddiScreenDesktopMax})`
};
export const GAP_MAP = {
    MOBILE: LayoutAddiGridMobileGap,
    TABLET: LayoutAddiGridTabletGap,
    DESKTOP: LayoutAddiGridDesktopGap,
    DESKTOP_HD: LayoutAddiGridDesktopGap
};
export const GUTTER_MAP = {
    MOBILE: LayoutAddiGridMobileGutter,
    TABLET: LayoutAddiGridTabletGutter,
    DESKTOP: LayoutAddiGridDesktopGutter,
    DESKTOP_HD: LayoutAddiGridDesktopGutter
};
//# sourceMappingURL=media-queries.js.map